import { useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { Lock, ArrowRight, CheckCircle2, XCircle } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";
import Logo from "../components/Logo";

export default function ResetPasswordPage() {
  const { token } = useParams();
  const nav = useNavigate();
  const [pwd, setPwd] = useState("");
  const [pwd2, setPwd2] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [err, setErr] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    if (pwd !== pwd2) return toast.error("Les mots de passe ne correspondent pas");
    if (pwd.length < 8) return toast.error("Minimum 8 caractères");
    setLoading(true);
    try {
      await api.post("/auth/password/reset", { token, new_password: pwd });
      setDone(true);
      setTimeout(() => nav("/admin/connexion"), 2500);
    } catch (er) {
      setErr(er?.response?.data?.detail || "Lien invalide ou expiré");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-ink text-white grid place-items-center p-6" data-testid="reset-password-page">
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_30%_20%,#D4AF37,transparent_60%)]" />
      <div className="relative w-full max-w-md">
        <div className="text-center">
          <Logo className="w-20 h-20 mx-auto" />
          <h1 className="font-serif text-3xl mt-6 leading-tight">Nouveau mot de passe</h1>
        </div>
        {err ? (
          <div className="mt-10 bg-white text-foreground p-8 rounded-sm shadow-2xl text-center space-y-3" data-testid="reset-error">
            <XCircle className="w-14 h-14 mx-auto text-crimson" />
            <p className="font-serif text-xl text-ink">Lien invalide</p>
            <p className="text-sm text-foreground/65">{err}</p>
            <Link to="/mot-de-passe-oublie" className="inline-block mt-2 text-sm font-semibold text-ink hover:text-gold-dark">
              Demander un nouveau lien
            </Link>
          </div>
        ) : done ? (
          <div className="mt-10 bg-white text-foreground p-8 rounded-sm shadow-2xl text-center space-y-3" data-testid="reset-done">
            <CheckCircle2 className="w-14 h-14 mx-auto text-emerald-500" />
            <p className="font-serif text-xl text-ink">Mot de passe modifié.</p>
            <p className="text-sm text-foreground/60">Redirection vers la connexion…</p>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-10 bg-white text-foreground rounded-sm p-8 space-y-4 shadow-2xl">
            <FieldPwd label="Nouveau mot de passe" v={pwd} on={setPwd} test="reset-pwd" />
            <FieldPwd label="Confirmer" v={pwd2} on={setPwd2} test="reset-pwd-2" />
            <button disabled={loading} className="btn-primary w-full justify-center" data-testid="reset-submit">
              {loading ? "…" : <>Valider <ArrowRight className="w-4 h-4" /></>}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

function FieldPwd({ label, v, on, test }) {
  return (
    <div>
      <label className="block text-[0.7rem] uppercase tracking-[0.16em] font-semibold text-foreground/60 mb-2">{label}</label>
      <div className="relative">
        <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-foreground/40" />
        <input required type="password" minLength={8} value={v} onChange={(e) => on(e.target.value)}
               className="w-full border border-border rounded-sm pl-10 pr-3 py-3 text-sm focus:border-ink outline-none"
               data-testid={test} />
      </div>
    </div>
  );
}
